import React from "react";
import { Reveal, Ornament } from "./Ornament";
import { Phone, FileText, ArrowUpRight } from "lucide-react";

export default function CTASection() {
  return (
    <section
      id="cta"
      className="relative bg-[var(--lu-ivory)] section-y overflow-hidden"
      data-testid="cta-section"
    >
      {/* Decorative sunburst backdrop */}
      <div
        aria-hidden
        className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full opacity-40"
        style={{
          background:
            "radial-gradient(circle at center, rgba(201,160,80,0.20), transparent 60%)",
        }}
      />

      <div className="container-lux relative">
        <div className="text-center max-w-3xl mx-auto">
          <p className="kicker text-[var(--lu-gold-dark)]">Ready Whenever You Are</p>
          <h2 className="mt-6 h-editorial text-[52px] sm:text-[72px] lg:text-[96px] text-[var(--lu-black)]">
            Let's design{" "}
            <span className="italic text-[var(--lu-gold-dark)]">your signature night</span>.
          </h2>
          <Ornament className="mt-10" />
          <p className="mt-8 text-[17px] leading-[1.9] text-black-70 font-light">Two ways to get started — request a bespoke quote for your event or book
            a twenty minute discovery call to explore what is possible.</p>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {/* Card A — Proposal */}
          <Reveal delay={1}>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
              }}
              data-testid="cta-proposal"
              className="group relative block bg-[var(--lu-black)] p-12 lg:p-16 border border-[var(--lu-gold)] overflow-hidden shadow-[var(--shadow-lux)] hover:shadow-[var(--shadow-lux-hover)] hover:-translate-y-1 transition-all duration-700"
            >
              <div className="deco-thin-frame" />
              <div className="relative">
                <FileText size={28} className="text-[var(--lu-gold)]" />
                <p className="mt-8 kicker">Option 01</p>
                <h3 className="mt-6 h-editorial text-[36px] lg:text-[46px] text-[var(--lu-ivory)] leading-[1.05]">Request<span className="italic text-[var(--lu-gold)]">Offering</span>
                </h3>
                <p className="mt-6 text-[15px] leading-[1.85] text-ivory-75 font-light max-w-md">Share your event details and dreams. In 48 hours
                  you will have a curated concept with performers, styling and price options.</p>
                <div className="mt-10 inline-flex items-center gap-3 text-[var(--lu-gold)] font-micro text-[11px]">Send Brief<ArrowUpRight
                    size={16}
                    className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                  />
                </div>
              </div>
            </a>
          </Reveal>

          {/* Card B — Discovery Call */}
          <Reveal delay={2}>
            <a
              href={`tel:6943167877`}
              data-testid="cta-discovery"
              className="group relative block bg-[var(--lu-cream)] p-12 lg:p-16 border border-[var(--lu-gold-dark)] overflow-hidden shadow-[var(--shadow-lux)] hover:shadow-[var(--shadow-lux-hover)] hover:-translate-y-1 transition-all duration-700"
            >
              <div className="deco-thin-frame" />
              <div className="relative">
                <Phone size={28} className="text-[var(--lu-gold-dark)]" />
                <p className="mt-8 kicker text-[var(--lu-gold-dark)]">Option 02</p>
                <h3 className="mt-6 h-editorial text-[36px] lg:text-[46px] text-[var(--lu-black)] leading-[1.05]">
                  Book a{" "}
                  <span className="italic text-[var(--lu-gold-dark)]">Discovery Call</span>
                </h3>
                <p className="mt-6 text-[15px] leading-[1.85] text-black-70 font-light max-w-md">A twenty-minute conversation with Stamatina to understand the vision, the
                  date and your location — and then, curated inspiration via email.</p>
                <div className="mt-10 inline-flex items-center gap-3 text-[var(--lu-gold-dark)] font-micro text-[11px]">Call · 694 316 7877<ArrowUpRight
                    size={16}
                    className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                  />
                </div>
              </div>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
